module.exports = __webpack_public_path__ + "media/images/front/icon_sumi-3a0fae3e523af5ff2f95d0868cab6124.png";